import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "fiscal-reports"
};
var _hoisted_2 = {
  key: 0,
  class: "spinner-overlay"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "d-flex flex-column fl-a-c fl-j-c"
};
var _hoisted_5 = {
  class: "fiscal-report-item"
};
var _hoisted_6 = {
  class: "fiscal-report-name"
};
var _hoisted_7 = {
  class: "fiscal-report-item"
};
var _hoisted_8 = {
  class: "fiscal-report-name"
};
var _hoisted_9 = {
  class: "fiscal-report-item"
};
var _hoisted_10 = {
  class: "fiscal-report-name"
};
var _hoisted_11 = {
  class: "date-and-print"
};
var _hoisted_12 = {
  class: "fiscal-report-item",
  style: {
    "margin-bottom": "20px"
  }
};
var _hoisted_13 = {
  class: "fiscal-report-name"
};
var _hoisted_14 = {
  class: "date-and-print"
};
var _hoisted_15 = {
  class: "fiscal-report-item"
};
var _hoisted_16 = {
  class: "fiscal-report-name"
};
var _hoisted_17 = {
  class: "date-and-print"
};
var _hoisted_18 = {
  class: "fiscal-report-item",
  style: {
    "margin-bottom": "20px"
  }
};
var _hoisted_19 = {
  class: "fiscal-report-name"
};
var _hoisted_20 = {
  class: "date-and-print"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_date_picker = _resolveComponent("el-date-picker");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisible,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return _ctx.modalVisible = $event;
    })
  }, {
    header: _withCtx(function () {
      return [_createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("compliance.fiscal-reports")), 1)];
    }),
    default: _withCtx(function () {
      return [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
        class: "spinner",
        loading: true
      })])) : _createCommentVNode("", true), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("compliance.x-user-report")), 1), _createVNode(_component_el_button, {
        class: "print-btn",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.printReport('xUser');
        }),
        disabled: _ctx.loading
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("completeorder.print")), 1)];
        }),
        _: 1
      }, 8, ["disabled"])]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("compliance.x-turnover-report")), 1), _createVNode(_component_el_button, {
        class: "print-btn",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.printReport('xTurnover');
        }),
        disabled: _ctx.loading
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("completeorder.print")), 1)];
        }),
        _: 1
      }, 8, ["disabled"])]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("compliance.z-user-report")), 1), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_date_picker, {
        modelValue: _ctx.zUserReportDate,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _ctx.zUserReportDate = $event;
        }),
        type: "date",
        placeholder: "Pick a day",
        "disabled-date": _ctx.disabledDate,
        "clear-icon": null
      }, null, 8, ["modelValue", "disabled-date"]), _createVNode(_component_el_button, {
        class: "print-btn",
        disabled: _ctx.disabledPrint('user') || _ctx.loading,
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.printReport('zUser');
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("completeorder.print")), 1)];
        }),
        _: 1
      }, 8, ["disabled"])])]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("compliance.z-turnover-report")), 1), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_date_picker, {
        modelValue: _ctx.zTurnoverReportDate,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return _ctx.zTurnoverReportDate = $event;
        }),
        type: "date",
        placeholder: "Pick a day",
        "disabled-date": _ctx.disabledDate,
        "clear-icon": null
      }, null, 8, ["modelValue", "disabled-date"]), _createVNode(_component_el_button, {
        class: "print-btn",
        disabled: _ctx.disabledPrint('turnover'),
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return _ctx.printReport('zTurnover');
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("completeorder.print")), 1)];
        }),
        _: 1
      }, 8, ["disabled"])])]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("compliance.z-user-report")) + " (Simulation) ", 1), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_date_picker, {
        modelValue: _ctx.zUserSimulationReportDate,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return _ctx.zUserSimulationReportDate = $event;
        }),
        disabled: "",
        type: "date",
        "clear-icon": null
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "print-btn",
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return _ctx.printReport('zUserSimulation');
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("completeorder.print")), 1)];
        }),
        _: 1
      })])]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_18, [_createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("compliance.z-turnover-report")) + " (Simulation) ", 1), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_date_picker, {
        modelValue: _ctx.zTurnoverSimulationReportDate,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
          return _ctx.zTurnoverSimulationReportDate = $event;
        }),
        type: "date",
        disabled: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "print-btn",
        onClick: _cache[9] || (_cache[9] = function ($event) {
          return _ctx.printReport('zTurnoverSimulation');
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("completeorder.print")), 1)];
        }),
        _: 1
      })])])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}